"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMobileComponent = exports.NavigationComponent = void 0;
var NavigationComponent_1 = require("./NavigationComponent");
Object.defineProperty(exports, "NavigationComponent", { enumerable: true, get: function () { return NavigationComponent_1.NavigationComponent; } });
var NavigationMobileComponent_1 = require("./NavigationMobileComponent");
Object.defineProperty(exports, "NavigationMobileComponent", { enumerable: true, get: function () { return NavigationMobileComponent_1.NavigationMobileComponent; } });
